<ng-container *ngIf="procedureShowed && procedure">
  <app-create-procedure
    [idEditMode]="true"
    [procedure]="procedure"
    [readOnly]="readOnly"
    [openLogigramme]="openLogigramme"
    [emargementData]="emargementData"
    [emargementUser]="emargementUser"
    [emargementForm]="emargementForm"
    (emargementValidated)="onEmargementValidated()"
    (input)="onProcedureModified()"
    >
  </app-create-procedure>
</ng-container>
